window.customElements.define(
  "fostr-mobilemenu",
  class FostrMobileMenu extends HTMLElement {
    constructor() {
      super();

      this.isVisible = false;
      this.transitionTime = 300;
      this.animationStyle = null;
      this.mobilemenuEl = null;
      this.pageWrapEl = null;
      this.isHiddenClass = "mobilemenu--hidden";
      this.isVisibleClass = "mobilemenu--isVisible";
      this.isActiveClass = "active";
      this.dropdownListTarget = ".mobilemenu__link";
      this.dropdownExpandedListTarget = ".mobilemenu__link.mobilemenuExpanded";
      this.tierActiveTarget = "fostr-mobilemenu-tier." + this.isActiveClass;
      this.linkTarget = ".mobilemenu__link";
      this.mobilemenuToggleTarget = '[data-mobilemenu="toggle"]';
      this.mobilemenuCloseTarget = "#focus-close-mm,fostr-mobilemenu-curtain";

      // Add focus trap related properties
      this._lastFocusedElement = null;
      this._handleFocusTrap = this._handleFocusTrap.bind(this);

      // Track the elements that triggered navigation to next tiers
      this._tierFocusHistory = new Map();

      // Track the element that opened the mobile menu
      this._menuTriggerElement = null;
      this._menuTriggerEvent = null;
    }

    connectedCallback() {
      this.mobilemenuAddCurtain();
      this.mobilemenuEl = this.querySelector("fostr-mobilemenu aside");
      this.pageWrapEl = document.querySelector(".fostr-mobilemenu-page");
      this.setMobilemenuAnimationStyle();
      this.setMobilemenu();

      let toggleButtons = document.querySelectorAll(
        this.mobilemenuToggleTarget
      );
      for (var i = 0; i < toggleButtons.length; i++) {
        // Bind the methods once and store them
        this._boundToggleClick = this.toggleButtonEventClick.bind(this);
        this._boundToggleKeydown = this.toggleButtonEventClick.bind(this);

        toggleButtons[i].addEventListener("click", this._boundToggleClick);
        toggleButtons[i].addEventListener("keydown", this._boundToggleKeydown);
      }

      // Event Listeners
      this.addEventListener("click", this.mobilemenuCloseEventClick.bind(this));
      this.addEventListener("keydown", this.handleKeydown.bind(this));
      this.addEventListener("click", this.dropdownListEventClick.bind(this));
      this.addEventListener(
        "click",
        this.dropdownListHideEventClick.bind(this)
      );
      this.addEventListener("click", this.backButtonEventClick.bind(this));
      this.addEventListener("click", this.tierLinkEventClick.bind(this));
      this.addEventListener("keydown", (event) => {
        if (event.key === "Escape" || event.code === "Escape") {
          this.previousTier();
        }
      });
    }

    disconnectedCallback() {
      // Remove classes
      this.pageWrapEl.classList.remove("active");
      this.pageWrapEl.classList.remove("mobilemenu--push-left");
      this.pageWrapEl.classList.remove("mobilemenu--push-right");
      this.pageWrapEl.classList.remove("mobilemenu--overlay-left");
      this.pageWrapEl.classList.remove("mobilemenu--overlay-right");
      this.pageWrapEl.classList.remove("mobilemenu--overlay-bottom");

      // Remove eventListeners
      let toggleButtons = document.querySelectorAll(
        this.mobilemenuToggleTarget
      );
      for (var i = 0; i < toggleButtons.length; i++) {
        toggleButtons[i].removeEventListener("click", this._boundToggleClick);
        toggleButtons[i].removeEventListener(
          "keydown",
          this._boundToggleKeydown
        );
      }

      this.removeEventListener(
        "click",
        this.mobilemenuCloseEventClick.bind(this)
      );
      this.removeEventListener("keydown", this.handleKeydown.bind(this));
      this.removeEventListener("click", this.dropdownListEventClick.bind(this));
      this.removeEventListener(
        "click",
        this.dropdownListHideEventClick.bind(this)
      );
      this.removeEventListener("click", this.backButtonEventClick.bind(this));
      this.removeEventListener("click", this.tierLinkEventClick.bind(this));
      this.removeEventListener("keydown", (event) => {
        if (event.key === "Escape" || event.code === "Escape") {
          this.previousTier();
        }
      });

      // Reset properties
      this.animationStyle = null;
    }

    // Methods
    mobilemenuHide() {
      this.mobilemenuEl.classList.remove("mobilemenuExpanded");
      this.classList.remove(this.isVisibleClass);
      this.pageWrapEl.classList.remove(this.isActiveClass);
      this.isVisible = false;
      this.setFirstTier();
      this.mobilemenuEl.blur();
      this.mobilemenuEl.removeAttribute("tabindex", "-1");
      document.querySelector(".mobilemenu-button").classList.remove("open");
      document.querySelector(".mobilemenu-button-close").style.display = "none";
      document.querySelector(".mobilemenu-button").style.display = "flex";
      document.documentElement.classList.remove("overflow-hidden");
      document.documentElement.classList.remove("keyboard-nav"); // Remove keyboard-nav class
      document
        .getElementById("shopify-section-fostr-mobilemenu")
        .classList.add("hidden");

      // Remove focus trap
      document.removeEventListener("keydown", this._handleFocusTrap);

      // Restore focus to the element that triggered the menu to open
      if (this._menuTriggerElement) {
        this._menuTriggerElement.focus();
        this._menuTriggerElement = null;
      }
    }

    mobilemenuShow() {
      this.mobilemenuEl.classList.add("mobilemenuExpanded");
      this.classList.add(this.isVisibleClass);
      this.pageWrapEl.classList.add(this.isActiveClass);
      this.isVisible = true;

      document.querySelector(".mobilemenu-button").classList.add("open");
      this.mobilemenuEl.setAttribute("tabindex", "-1");

      // Store last focused element before opening menu
      this._lastFocusedElement = document.activeElement;

      document.querySelector(".mobilemenu-button").style.display = "none";
      document.querySelector(".mobilemenu-button-close").style.display = "flex";
      document.documentElement.classList.add("overflow-hidden");
      document
        .getElementById("shopify-section-fostr-mobilemenu")
        .classList.remove("hidden");

      document.documentElement.classList.add("keyboard-nav");
      // Focus the close button after a short delay to ensure the menu is fully opened

      setTimeout(() => {
        const aside = document.getElementById("mobilemenu");
        if (aside) {
          aside.focus();
        }
      }, 100);

      // Add focus trap
      document.addEventListener("keydown", this._handleFocusTrap);
    }

    toggleButtonEventClick(event) {
      // For keyboard events, only proceed if Enter or Space is pressed
      if (event.type === "keydown") {
        if (event.key !== "Enter" && event.key !== " ") {
          return;
        }
        // Prevent default behavior for space key
        event.preventDefault();
      }

      // Store both the element and the event that triggered the menu to open
      if (!this.isVisible) {
        this._menuTriggerElement = event.target;
        this._menuTriggerEvent = event;
      }

      this.mobilemenuToggle();
      this.setFirstTier();
    }

    mobilemenuAddCurtain() {
      if (document.querySelector("fostr-mobilemenu-curtain")) {
        return;
      }
      this.innerHTML =
        "<fostr-mobilemenu-curtain></fostr-mobilemenu-curtain>" +
        this.innerHTML;
    }

    dropdownListEventClick(event) {
      if (!event.target.closest(this.dropdownListTarget)) return false;

      let dropdownListEl = event.target.closest(this.dropdownListTarget);
      if (!dropdownListEl.classList.contains("mobilemenuExpanded")) {
        dropdownListEl.classList.add("mobilemenuExpanded");
        let submenuId = dropdownListEl.getAttribute("data-submenu");

        if (submenuId) {
          // Find the submenu element
          const submenuElement = document.getElementById(submenuId);
          if (submenuElement) {
            // Make all interactive elements focusable
            const focusableElements =
              submenuElement.querySelectorAll("a, button");
            focusableElements.forEach((element) => {
              element.setAttribute("tabindex", "0");
            });

            // Focus the first interactive element
            if (focusableElements.length > 0) {
              focusableElements[0].focus();
            }
          }
        }
        return true;
      }

      dropdownListEl.classList.remove("mobilemenuExpanded");
      return true;
    }

    dropdownListHideEventClick(event) {
      console.log(event);
      // Check if the clicked element is inside '.mobilemenu__link-list-goback'
      const goBackElement = event.target.closest(
        ".mobilemenu__link-list-goback"
      );
      if (!goBackElement) return false;

      // If the element has the 'top-level' class, remove 'active' from the corresponding 'fostr-mobilemenu-tier'
      if (goBackElement.classList.contains("top-level")) {
        const mobileMenuTier = goBackElement.closest("fostr-mobilemenu-tier");
        if (mobileMenuTier) {
          mobileMenuTier.classList.remove("active");
          const mmtActiveElements =
            mobileMenuTier.querySelectorAll("a, button");
          mmtActiveElements.forEach((element) => {
            element.setAttribute("tabindex", "-1");
          });

          // Get the element that should receive focus
          const elementToFocus = this._tierFocusHistory.get(mobileMenuTier.id);

          // Find the parent element that triggered navigation to this tier
          const MMParentElement = document.querySelector(
            `fostr-mobilemenu-link-block button[data-submenu="${mobileMenuTier.id}"]`
          );

          const tierBodyParent = document
            .querySelector(
              `fostr-mobilemenu-link-block button[data-submenu="${mobileMenuTier.id}"]`
            )
            .closest("fostr-mobilemenu-tier-body");

          if (tierBodyParent) {
            const focusableParentElements =
              this.getFocusableElements(tierBodyParent);
            focusableParentElements.forEach((element) => {
              element.setAttribute("tabindex", "0");
            });
          }

          if (MMParentElement) {
            MMParentElement.classList.remove("mobilemenuExpanded");

            // Set focus back to the parent element
            setTimeout(() => {
              if (elementToFocus) {
                elementToFocus.focus();
              } else if (MMParentElement) {
                MMParentElement.focus();
              }
            }, 50);
          }
        }
        return true;
      }

      // If it's not top-level, handle other logic (sublevel toggling)
      const mobileMenuBlock = goBackElement.closest(
        "fostr-mobilemenu-link-block"
      );

      const mmbActiveElements = mobileMenuBlock.querySelectorAll(
        'a, button:not([id^="mobilemenu__link-"])'
      );
      mmbActiveElements.forEach((element) => {
        element.setAttribute("tabindex", "-1");
      });
      const parentMenuDiv = mobileMenuBlock.querySelector(".mobilemenu__link");

      if (!parentMenuDiv) return false;

      // Toggle the expanded state
      if (parentMenuDiv.classList.contains("mobilemenuExpanded")) {
        parentMenuDiv.classList.remove("mobilemenuExpanded");
        // Focus the parent menu div after collapsing
        setTimeout(() => {
          parentMenuDiv.focus();
        }, 50);
      } else {
        parentMenuDiv.classList.add("mobilemenuExpanded");
      }

      return true;
    }

    dropdownListCollapseAll() {
      // close all expanded dropdown lists
      let expandedDropdownListEls = this.mobilemenuEl.querySelectorAll(
        this.dropdownExpandedListTarget
      );

      setTimeout(() => {
        for (var i = 0; i < expandedDropdownListEls.length; i++) {
          expandedDropdownListEls[i].classList.remove("mobilemenuExpanded");
        }
      }, this.transitionTime);
    }

    nextTier(tierEl) {
      if (!tierEl) {
        return;
      }

      // Store the current focused element for this tier
      const currentFocusedElement = document.activeElement;
      this._tierFocusHistory.set(tierEl.id, currentFocusedElement);

      tierEl.classList.add(this.isActiveClass);

      // Set tabindex=-1 for all active tier elements except the current one
      const allActiveTiers = this.mobilemenuEl.querySelectorAll(
        "fostr-mobilemenu-tier"
      );
      allActiveTiers.forEach((activeTier) => {
        if (activeTier.id !== tierEl.id) {
          const focusableElements = this.getFocusableElements(activeTier);
          focusableElements.forEach((element) => {
            element.setAttribute("tabindex", "-1");
          });
        }
      });

      this.attachScrollingEventListener();

      this.setBackButton();
      this.mobilemenuEl.blur();
      this.mobilemenuEl.removeAttribute("tabindex", "-1");
      tierEl.setAttribute("tabindex", "-1");
      const focusableElements = this.getFocusableElements(tierEl);
      // Make all interactive elements in the tier focusable
      //const focusableElements = tierEl.querySelectorAll("a, button");
      focusableElements.forEach((element) => {
        element.setAttribute("tabindex", "0");
      });

      // Focus the first interactive element
      if (focusableElements.length > 0) {
        focusableElements[0].focus();
      } else {
        tierEl.focus();
      }
    }

    previousTier() {
      var activeTiers = this.mobilemenuEl.querySelectorAll(
        this.tierActiveTarget
      );
      var lastActiveTier = activeTiers[activeTiers.length - 1];

      // Get the element that should receive focus (the one that triggered navigation to this tier)
      const elementToFocus = this._tierFocusHistory.get(lastActiveTier.id);

      lastActiveTier.classList.remove(this.isActiveClass);

      // Make all elements in the previous tier focusable again
      const previousTier = activeTiers[activeTiers.length - 2];
      if (previousTier) {
        // Get all elements in the previous tier and remove tabindex=-1
        const allElements = previousTier.querySelectorAll("*");
        allElements.forEach((element) => {
          if (element.getAttribute("tabindex") === "-1") {
            element.removeAttribute("tabindex");
          }
        });
      }

      this.setBackButton();
      this.dropdownListCollapseAll();

      // Set focus back to the element that had it before
      if (elementToFocus) {
        setTimeout(() => {
          elementToFocus.focus();
        }, 50);
      }
    }

    setBackButton() {
      if (!this.mobilemenuEl) {
        return;
      }

      let backButton = this.mobilemenuEl.querySelector(
        "fostr-mobilemenu-button-back"
      );
      if (!backButton) {
        return false;
      }

      if (
        this.mobilemenuEl.querySelectorAll(this.tierActiveTarget).length == 1
      ) {
        backButton.classList.add(this.isHiddenClass);
      } else {
        backButton.classList.remove(this.isHiddenClass);
      }
      return true;
    }

    backButtonEventClick(event) {
      if (!event.target.closest('fostr-mobilemenu [data-mobilemenu="back"]')) {
        return false;
      }

      this.previousTier();

      return true;
    }

    unsetAllActiveTiers() {
      let activeTierEls = this.mobilemenuEl.querySelectorAll(
        this.tierActiveTarget
      );
      let self = this;
      setTimeout(() => {
        for (var i = 0; i < activeTierEls.length; i++) {
          let activeTierEl = activeTierEls[i];
          activeTierEl.classList.remove(self.isActiveClass);
        }
      }, this.transitionTime);
    }

    setFirstTier() {
      let tier1El = this.mobilemenuEl.querySelector("#tier-1-0-0");

      if (!tier1El) {
        return;
      }

      // Store the current focused element before making changes
      const currentFocusedElement = document.activeElement;

      if (tier1El.classList.contains(this.isActiveClass)) {
        // We're going back to first level from a deeper level
        this.unsetAllActiveTiers();
        this.dropdownListCollapseAll();

        // Clear the focus history as we're back at the root
        this._tierFocusHistory.clear();

        // Make all elements in the first tier focusable again
        const focusableElements = this.getFocusableElements(tier1El);
        focusableElements.forEach((element) => {
          element.setAttribute("tabindex", "0");
        });

        // Focus the first focusable element in the first tier
        setTimeout(() => {
          if (focusableElements.length > 0) {
            focusableElements[0].focus();
          } else {
            tier1El.focus();
          }
        }, 50);
      } else {
        tier1El.classList.add(this.isActiveClass);
        this.attachScrollingEventListener();

        // Make all elements in the first tier focusable
        const focusableElements = this.getFocusableElements(tier1El);
        focusableElements.forEach((element) => {
          element.setAttribute("tabindex", "0");
        });

        // Store the current focused element in the history
        if (currentFocusedElement) {
          this._tierFocusHistory.set(tier1El.id, currentFocusedElement);
        }
      }

      this.setBackButton();
    }

    mobilemenuToggle() {
      if (!this.mobilemenuEl) {
        return;
      }

      if (!this.isVisible) {
        this.mobilemenuShow();
      } else {
        this.mobilemenuHide();
      }
    }

    setMobilemenuAnimationStyle() {
      if (!this.mobilemenuEl) {
        return false;
      }

      this.animationStyle = this.mobilemenuEl.classList.contains(
        "mobilemenu--push-left"
      )
        ? "push-left"
        : this.animationStyle;
      this.animationStyle = this.mobilemenuEl.classList.contains(
        "mobilemenu--push-right"
      )
        ? "push-right"
        : this.animationStyle;
      this.animationStyle = this.mobilemenuEl.classList.contains(
        "mobilemenu--overlay-left"
      )
        ? "overlay-left"
        : this.animationStyle;
      this.animationStyle = this.mobilemenuEl.classList.contains(
        "mobilemenu--overlay-right"
      )
        ? "overlay-right"
        : this.animationStyle;
      this.animationStyle = this.mobilemenuEl.classList.contains(
        "mobilemenu--overlay-bottom"
      )
        ? "overlay-bottom"
        : this.animationStyle;
    }

    isAnimationStylePush() {
      return (
        this.animationStyle === "push-left" ||
        this.animationStyle === "push-right"
      );
    }

    setMobilemenu() {
      if (!this.mobilemenuEl) {
        return false;
      }

      if (!this.pageWrapEl) {
        return;
      }

      this.pageWrapEl.classList.add("mobilemenu--" + this.animationStyle);
      this.classList.add("mobilemenu--" + this.animationStyle);

      return true;
    }

    // Event handlers
    tierLinkEventClick(event) {
      if (!event.target.closest(this.linkTarget)) {
        return false;
      }

      if (event.target.tagName === "A") {
        return;
      }

      let linkEl = event.target;
      if (linkEl.nextElementSibling) {
        return true;
      }

      let nextTierEl = this.mobilemenuEl.querySelector(
        "#" + linkEl.id.replace("-link", "")
      );
      if (!nextTierEl) {
        return true;
      }

      this.nextTier(nextTierEl);

      return true;
    }

    mobilemenuCloseEventClick(event) {
      if (!event.target.closest(this.mobilemenuCloseTarget)) return false;

      this.mobilemenuHide();
    }

    attachScrollingEventListener() {
      if (!this.mobilemenuEl) {
        return;
      }

      let lastActiveTierEl = this.mobilemenuEl.querySelectorAll(
        "." + this.isActiveClass + ":not(.mobilemenu--watchingScroll)"
      )[
        this.mobilemenuEl.querySelectorAll(
          "." + this.isActiveClass + ":not(.mobilemenu--watchingScroll)"
        ).length - 1
      ];
      if (!lastActiveTierEl) {
        return;
      }

      let lastActiveTierBodyEl = lastActiveTierEl.querySelector(
        "fostr-mobilemenu-tier-body"
      );
      if (!lastActiveTierBodyEl) {
        return;
      }

      lastActiveTierBodyEl.addEventListener(
        "scroll",
        () => {
          if (!lastActiveTierBodyEl) {
            return;
          }

          if (lastActiveTierBodyEl.scrollTop > 0) {
            lastActiveTierEl.classList.add("mobilemenu--scrolling");
          } else {
            lastActiveTierEl.classList.remove("mobilemenu--scrolling");
          }
        },
        {
          passive: true,
        }
      );

      lastActiveTierEl.classList.add("mobilemenu--watchingScroll");
    }

    handleKeydown(event) {
      const target = event.target;

      switch (event.key) {
        case "Enter":
        case " ":
          // Only prevent default and handle custom logic if it's not a regular link
          if (target.tagName === "A") {
            return; // Let the default link behavior happen
          }

          if (target.closest(this.mobilemenuCloseTarget)) {
            this.mobilemenuCloseEventClick(event);
          } else {
            const element = target.closest(this.linkTarget);
            if (element) {
              // Check if this is a tier navigation or dropdown
              if (element.id && element.id.startsWith("tier-link-")) {
                this.tierLinkEventClick(event);
              } else if (element.hasAttribute("data-submenu")) {
                this.dropdownListEventClick(event);
              }
            } else if (target.closest(".mobilemenu__link-list-goback")) {
              this.dropdownListHideEventClick(event);
            } else if (target.closest('[data-mobilemenu="back"]')) {
              this.backButtonEventClick(event);
            }
          }
          event.preventDefault();
          break;

        case "Escape":
          // If we're in a submenu/tier, go back one level
          const activeTiers = this.mobilemenuEl.querySelectorAll(
            this.tierActiveTarget
          );
          if (activeTiers.length > 1) {
            this.previousTier();
          } else {
            // If we're at the root level, close the entire menu
            this.mobilemenuHide();
          }
          event.preventDefault();
          break;

        case "ArrowDown":
          this.focusNextElement(target);
          event.preventDefault();
          break;

        case "ArrowUp":
          this.focusPreviousElement(target);
          event.preventDefault();
          break;

        case "Tab":
          // Let Tab work naturally for keyboard navigation
          break;
      }
    }

    focusNextElement(currentElement) {
      const focusableElements = this.getFocusableElements(this.mobilemenuEl);
      const currentIndex = focusableElements.indexOf(currentElement);
      const nextElement =
        focusableElements[currentIndex + 1] || focusableElements[0];
      nextElement?.focus();
    }

    focusPreviousElement(currentElement) {
      const focusableElements = this.getFocusableElements(this.mobilemenuEl);
      const currentIndex = focusableElements.indexOf(currentElement);
      const previousElement =
        focusableElements[currentIndex - 1] ||
        focusableElements[focusableElements.length - 1];
      previousElement?.focus();
    }

    getFocusableElements(element) {
      if (!element) return [];

      let selectors = [
        "button:not([disabled])",
        "[href]",
        "input:not([disabled])",
        "select:not([disabled])",
        "textarea:not([disabled])",
        '[tabindex]:not([tabindex="-1"]):not([disabled])',
        ".mobilemenu__link",
        ".mobilemenu-button-close",
      ];

      const elements = Array.from(
        element.querySelectorAll(selectors.join(","))
      ).filter((el) => {
        const style = window.getComputedStyle(el);
        return (
          style.display !== "none" &&
          style.visibility !== "hidden" &&
          style.opacity !== "0"
        );
      });

      return elements;
    }

    _handleFocusTrap(event) {
      if (event.key !== "Tab") return;

      // Get the focus-close-mm element first
      const focusCloseButton = document.getElementById("focus-close-mm");
      if (!focusCloseButton) return;

      // Get the current active tier
      const activeTier =
        this.mobilemenuEl.querySelector(".mobilemenu__tier-2.active") ||
        this.mobilemenuEl.querySelector(".mobilemenu__tier-1.active");

      if (!activeTier) return;

      // Get all focusable elements within the active tier's body
      const tierBody = activeTier.querySelector("fostr-mobilemenu-tier-body");
      if (!tierBody) return;

      const tierFocusableElements = this.getFocusableElements(tierBody);

      // Create array with focus-close-mm as first element
      const focusableElements = [focusCloseButton, ...tierFocusableElements];

      if (focusableElements.length === 0) return;

      const firstFocusableElement = focusableElements[0];
      const lastFocusableElement =
        focusableElements[focusableElements.length - 1];

      if (event.shiftKey) {
        // Shift + Tab
        if (document.activeElement === firstFocusableElement) {
          event.preventDefault();
          lastFocusableElement.focus();
        }
      } else {
        // Tab
        if (document.activeElement === lastFocusableElement) {
          event.preventDefault();
          firstFocusableElement.focus();
        }
      }
    }
  }
);
